import { getMailboxes } from './mail'
import { getUsers } from './auth'
import { getDatasets } from './storage'
import type { BGlobalClass, BGlobalTarget } from '../types'

// The records a global relation field can pick from, per class — read from the service that owns
// them (Mail, Auth, Storage). Forms only pick; creating these records happens in their own pages.
export async function loadGlobalOptions(targetClass: BGlobalClass, businessId: string | undefined): Promise<{ id: string; label: string }[]> {
  if (targetClass === 'mailbox') {
    const { data } = await getMailboxes()
    return data.map(m => ({ id: m.id, label: `${m.name} — ${m.smtpFromAddress || m.user}${m.smtpEnabled ? '' : ' (sending off)'}` }))
  }
  if (targetClass === 'user') {
    if (!businessId) return []
    const { data } = await getUsers(businessId)
    return data.filter(u => u.isActive !== false).map(u => ({ id: u.id, label: u.fullName ? `${u.fullName} (${u.email})` : u.email }))
  }
  const { data } = await getDatasets()
  return data.map(d => ({ id: d.id, label: d.title }))
}

export const toTargets = (opts: { id: string; label: string }[], ids: string[]): BGlobalTarget[] =>
  ids.map(id => ({ id, label: opts.find(o => o.id === id)?.label ?? null }))

export const GLOBAL_CLASS_TITLES: Record<BGlobalClass, string> = { user: 'User', mailbox: 'Mailbox', storage_dataset: 'Storage dataset' }
export const GLOBAL_RELATION_TYPE_TITLES = { belongs_to: 'Belongs to (one)', has_many: 'Has many', many_to_many: 'Many to many' } as const
